/**
 * How a purchase order came to be approved (signed off).
 *
 * - Manual: a user signed it off, through POST /job-signoff/signoff or by
 *   setting `approved` on PATCH /board-purchase.
 * - Automatic: the API signed it off on its own because it was the first
 *   purchase order of a job already past the Materials phase (Release 6.2.0).
 *
 * Null while the purchase order is not approved, and on sign-offs recorded
 * before this field existed.
 */
export enum BoardPurchaseApprovalOriginEnum {
  Manual = 'manual',
  Automatic = 'automatic',
}
